module.exports = __webpack_public_path__ + "static/media/lxyMusic.6845936.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/mp3/lxyMusic.mp3
// module id = 5BeN
// module chunks = 5